import {
  CraftsmanCostProps,
  Fireplace,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateFireplaceCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { fireplace, craftsmanQuality } = improvementsForTransaction;
  const zipCode = identification.address.PostalCode;

  if (
    !fireplace ||
    isUndefined(craftsmanQuality) ||
    isUndefined(zipCode) ||
    !ORDER_FEATURES.fireplace.hasFeature(improvementsForTransaction)
  )
    return undefined;

  const calculator = getCraftsmanCost(costProps);
  return calculator.getFireplaceCost({ ...(fireplace as Required<Fireplace>), zipCode });
};

export const {
  selectFireplaceCost,
  selectZipOnlyFireplaceCost,
  selectFireplaceCosts,
  selectFireplaceCostDisplay,
} = createFeatureCostSelectors({
  calculate: calculateFireplaceCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectFireplaceCost',
    zipOnly: 'selectZipOnlyFireplaceCost',
    costs: 'selectFireplaceCosts',
    display: 'selectFireplaceCostDisplay',
  },
});
